import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

import { fetchProfile } from "../../../../utils/fetchProfile";
import Navbar from "../../../../Components/Navbar";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import {
  TextField,
  Button,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Autocomplete,
  Box,
  Grid,
  Checkbox,
} from "@mui/material";
import { Slide, toast } from "react-toastify";

import { ModalConfirmation } from "../../../../Components/Fragments/Modals/ModalGeneral";
import ModalProcessCrosscoding from "../../../../Components/Fragments/Modals/ModalProcessCrosscoding";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
    border: "solid 1px #fff",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const HighlightedStyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundImage: "linear-gradient(#c9c30cff, #aea806ff)",
    border: "solid 1px #fff",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  height: "40px",
}));

function CrosscodedExcludedBrand() {
  const { listType } = useParams();

  const accessToken = Cookies.get("access_token") || "";

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const retailerUrl = queryParams.get("retailer");

  const [selectedRetailer, setSelectedRetailer] = useState([]);
  const [retailerOptions, setRetailerOptions] = useState([]);

  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageList = [5, 10, 50, 100];
  const [totalItems, setTotalItems] = useState("");

  const [dataTable, setDataTable] = useState([]);
  const [dataProfile, setDataProfile] = useState([]);
  const [formBody, setFormBody] = useState({
    multiple_selection: [],
    target_update: {},
    category_mode: "",
    retailer: "",
  });

  const [crosscodeLabel, setCrosscodeLabel] = useState("");
  const [processModalOpen, setProcessModalOpen] = useState(false);

  const [openDialogConfirmationExport, setOpenDialogConfirmationExport] =
    useState(false);
  const [viewDataExport, setViewDataExport] = useState({
    title: null,
    process_at: null,
  });

  const [filterColumnName, setFilterColumnName] = useState(
    listType == "crosscode" ? "namabrand" : "ret_brand"
  );

  const filterColumnNameOptionsCrosscoded = [
    { value: "", label: "Select", operator: "LIKE" },
    { value: "namabrand", label: "Brand", operator: "LIKE" },
    { value: "namagroup", label: "Category", operator: "LIKE" },
    { value: "ret_product", label: "RET_Product", operator: "LIKE" },
    { value: "ret_brand", label: "RET_Brand", operator: "LIKE" },
    { value: "ret_category", label: "RET_Category", operator: "LIKE" },
  ];

  const filterColumnNameOptionsExcluded = [
    { value: "", label: "Select", operator: "LIKE" },
    { value: "ret_product", label: "RET_Product", operator: "LIKE" },
    { value: "ret_brand", label: "RET_Brand", operator: "LIKE" },
    { value: "ret_category", label: "RET_Category", operator: "LIKE" },
  ];

  const [filterValue, setFilterValue] = useState("");

  const goToBrand = () => {
    window.location.href = `/data-processing/crosscode-brand?retailer=${selectedRetailer}`;
  };

  // fetching api
  async function fetchMainData() {
    setDataTable([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    queryParams.append("category_mode", listType);
    queryParams.append("page", currentPage);
    queryParams.append("size", itemsPerPage);
    queryParams.append("column_value", filterValue);
    queryParams.append("retailer", selectedRetailer);

    if (filterColumnName) {
      queryParams.append("column_name", filterColumnName);
    } else {
      queryParams.append(
        "column_name",
        listType === "crosscode" ? "namabrand" : "ret_brand"
      );
    }

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/data-processing-raw-crosscoding/rta_mt/brand` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTotalItems(data.pagination_info.total);
        setDataTable(data.data);
      } else {
        setDataTable([]);
      }
    } catch (error) {
      setDataTable([]);
    }

    setIsLoading(false);
  }

  async function fetchRetailerOptions() {
    setIsLoading(true);

    setRetailerOptions([]);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/data-processing-raw/rta_mt/retailer`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const { data } = await response.json();
        setRetailerOptions(data);
      } else {
        setRetailerOptions([]);
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  }

  const handleRetailerChange = (event) => {
    setSelectedRetailer(event.target.value);
    setFormBody((prev) => ({
      ...prev,
      retailer: event.target.value,
    }));
  };

  // checkbox
  const handleChangeMultipleSelection = (row) => () => {
    setFormBody((prev) => {
      const exists = prev.multiple_selection?.some(
        (item) =>
          item.ret_category === row.ret_category &&
          item.ret_brand === row.ret_brand &&
          item.ret_product === row.ret_product
      );

      const updated = exists
        ? prev.multiple_selection.filter(
            (item) =>
              !(
                item.ret_category === row.ret_category &&
                item.ret_brand === row.ret_brand &&
                item.ret_product === row.ret_product
              )
          )
        : [
            ...(prev.multiple_selection || []),
            {
              ret_category: row.ret_category,
              ret_brand: row.ret_brand,
              ret_product: row.ret_product,
            },
          ];

      return {
        ...prev,
        multiple_selection: updated,
      };
    });
  };

  // pagination
  const handlePageChange = (event, page) => {
    setCurrentPage(page + 1);
  };

  const handleChangeItemPerPageSelect = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  // process crosscoding
  const handleProcessReset = () => {
    if (
      Array.isArray(formBody?.multiple_selection) &&
      formBody.multiple_selection.length > 0
    ) {
      setCrosscodeLabel(
        <span
          dangerouslySetInnerHTML={{
            __html:
              "Apakah anda yakin untuk melakukan proses <strong>reset</strong> pada brand terpilih?",
          }}
        />
      );
      setFormBody((prev) => ({
        ...prev,
        category_mode: "reset",
      }));
      setProcessModalOpen(true);
    } else {
      toast.error("Harap memilih data terlebih dahulu!");
    }
  };

  const handleProcessExclude = () => {
    if (
      Array.isArray(formBody?.multiple_selection) &&
      formBody.multiple_selection.length > 0
    ) {
      setCrosscodeLabel(
        <span
          dangerouslySetInnerHTML={{
            __html:
              "Apakah anda yakin untuk melakukan proses <strong>exclude</strong> pada brand terpilih?",
          }}
        />
      );
      setFormBody((prev) => ({
        ...prev,
        category_mode: "excluded",
      }));
      setProcessModalOpen(true);
    } else {
      toast.error("Harap memilih data terlebih dahulu!");
    }
  };

  const handleCloseProcess = () => {
    setCrosscodeLabel("");
    setFormBody((prev) => ({
      ...prev,
      category_mode: "",
    }));
    setProcessModalOpen(false);
  };

  const handleProcess = async () => {
    setIsLoading(true);
    try {
      let apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/data-processing-raw-crosscoding/rta_mt/brand`;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formBody),
      });

      if (response.ok) {
        setProcessModalOpen(false);
        toast.success(`Data berhasil diproses`);
        setFormBody({
          multiple_selection: [],
          target_update: {},
          category_mode: "",
          retailer: selectedRetailer,
        });
        fetchMainData();
      } else {
        const message = await response.json();
        toast.error(message.detail);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Gagal memproses data!");
    }
    setIsLoading(false);
  };

  async function createExportProcess() {
    setIsLoading(true);
    try {
      const formData = {
        title: `Crosscoding Brand of ${listType} list`,
        retailer: "",
        category_mode: listType,
        is_brand_check: true,
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/data-processing-raw-crosscoding/process_queue/crosscodings`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (
        response.status === 201 ||
        response.status === 200 ||
        response.status === 202
      ) {
        toast.success("data akan diproses kedalam antrian", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 400) {
        const message = await response.json();
        toast.error(message?.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 404) {
        toast.error("data tidak ditemukan", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error("ada masalah saat menyimpan data", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error creating process queue:", error);
    }
    setIsLoading(false);
  }

  const handleConfirmationExport = async () => {
    setIsLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/process_queue/crosscodings/${listType}?is_brand_check=true`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      const { data } = await response.json();
      setOpenDialogConfirmationExport(true);
      setViewDataExport({
        title: data.data.title ?? "rawdata",
        process_at: data.process_at,
      });
    } else if (response.status === 400 || response.status === 404) {
      const { detail } = await response.json();
      toast.error(detail || "Data sedang diproses", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    } else {
      const { detail } = await response.json();
      toast.error(
        detail || "Tidak ditemukan excel, klik Process terlebih dahulu",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        }
      );
    }
    setIsLoading(false);
  };

  const handleCloseDialog = () => {
    setOpenDialogConfirmationExport(false);
    // clear data
    setViewDataExport({
      title: "",
      process_at: "",
    });
  };

  const handleExport = async () => {
    try {
      const queryParams = new URLSearchParams();
      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/process_queue/crosscodings/export/${listType}?is_brand_check=true` +
        // `${process.env.REACT_APP_API_URL}/api/v1/data-processing-raw-crosscoding/rta_mt/brand/export?category_mode=${listType}&sort_by=retailer&sort_order=asc` +
        (queryString ? `&${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200) {
        const blob = await response.blob();
        const filename = `Result of ${
          listType == "crosscode" ? "Crosscoded" : "Excluded"
        } Brand List.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        toast.success(`Result of Crosscoded berhasil di export!`);
        handleCloseDialog();
      } else {
        const message = await response.json();
        toast.error(
          message.detail || "An error occurred while exporting data."
        );
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while exporting data.");
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchMainData();
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [
    accessToken,
    filterValue,
    currentPage,
    itemsPerPage,
    selectedRetailer,
    filterColumnName,
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (retailerUrl) {
        setSelectedRetailer(retailerUrl);
        setFormBody((prev) => ({
          ...prev,
          retailer: retailerUrl,
        }));
      }
    }, 100);
    return () => {
      clearTimeout(handler);
    };
  }, [retailerUrl]);

  useEffect(() => {
    fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
      "COA",
      "TL",
      "13",
      "14",
    ]);
    fetchRetailerOptions();
  }, []);

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Data Processing"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allowed to access this page</div>
      </div>
    );
  }
  return (
    <Box>
      <Navbar
        active="Data Processing"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <Box className="content" sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <h2 style={{ fontSize: 28, fontFamily: "Montserrat", margin: 0 }}>
            {listType == "crosscode" ? "Crosscoded" : "Excluded"} Brand
          </h2>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Button
              className="button-pros"
              variant="contained"
              sx={{
                backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                border: "1px solid hsl(186, 89.90%, 27.30%)",
                borderRadius: "4px",
                color: "#fff",
                fontSize: "14px",
                textTransform: "none",
                "&:hover": {
                  backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                },
              }}
              onClick={goToBrand}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Back to Crosscoding Brand"}
            </Button>
            <Button
              className="button-pros"
              variant="contained"
              sx={{
                backgroundImage: "linear-gradient(#09a906ff, #078c05ff)",
                border: "1px solid hsl(186, 89.90%, 27.30%)",
                borderRadius: "4px",
                color: "#fff",
                fontSize: "14px",
                textTransform: "none",
                "&:hover": {
                  backgroundImage: "linear-gradient(#068004ff, #067504ff)",
                },
              }}
              onClick={createExportProcess}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Process"}
            </Button>
            <Button
              className="button-pros"
              variant="contained"
              sx={{
                backgroundImage: "linear-gradient(#09a906ff, #078c05ff)",
                border: "1px solid hsl(186, 89.90%, 27.30%)",
                borderRadius: "4px",
                color: "#fff",
                fontSize: "14px",
                textTransform: "none",
                "&:hover": {
                  backgroundImage: "linear-gradient(#068004ff, #067504ff)",
                },
              }}
              onClick={handleConfirmationExport}
              // onClick={handleExport}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Download"}
            </Button>
          </Box>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                boxShadow:
                  "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                borderRadius: "5px",
                p: 2,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Box sx={{ mb: 2 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "flex-start", sm: "center" },
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column-reverse", sm: "row" },
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", sm: "center" },
                          gap: 2,
                        }}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <h4
                            style={{
                              fontSize: 14,
                              fontFamily: "Montserrat",
                              margin: 0,
                              marginBottom: "4px",
                            }}
                          >
                            Retailer
                          </h4>
                          <Autocomplete
                            size="small"
                            options={retailerOptions || []}
                            getOptionLabel={(item) => item.retailer || ""}
                            value={
                              retailerOptions?.find(
                                (item) => item.retailer === selectedRetailer
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              handleRetailerChange({
                                target: {
                                  value: newValue ? newValue.retailer : "",
                                },
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                className="reporting-textfield"
                                sx={{ minWidth: { xs: "200px", sm: 300 } }}
                                placeholder="Select Retailer"
                              />
                            )}
                            isOptionEqualToValue={(item, value) =>
                              item.retailer === value.retailer
                            }
                            disableClearable
                          />
                        </div>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <h4
                            style={{
                              fontSize: 14,
                              fontFamily: "Montserrat",
                              margin: 0,
                              marginBottom: "4px",
                            }}
                          >
                            Filter By
                          </h4>
                          <TextField
                            id="select_column_name"
                            placeholder="Search by"
                            select
                            sx={{ width: { xs: "100%", sm: 200 } }}
                            size="small"
                            value={filterColumnName}
                            onChange={(e) => {
                              const newFilterColumnName = e.target.value;
                              setFilterColumnName(newFilterColumnName);
                            }}
                            className="reporting-textfield"
                          >
                            {(listType === "crosscode"
                              ? filterColumnNameOptionsCrosscoded
                              : filterColumnNameOptionsExcluded
                            ).map((data) => (
                              <MenuItem value={data.value} key={data.value}>
                                {data.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </div>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <h4
                            style={{
                              fontSize: 14,
                              fontFamily: "Montserrat",
                              margin: 0,
                              marginBottom: "4px",
                            }}
                          >
                            Search
                          </h4>
                          <TextField
                            value={filterValue}
                            onChange={(e) => {
                              setFormBody((prev) => ({
                                ...prev,
                                multiple_selection: [],
                              }));
                              setFilterValue(e.target.value);
                            }}
                            placeholder="Value"
                            sx={{ width: { xs: "100%", sm: 200 } }}
                            size="small"
                          />
                        </div>
                      </Box>
                      <Box
                        sx={{
                          mt: { xs: 1, sm: 0 },
                          display: "flex",
                          justifyContent:
                            listType == "crosscode"
                              ? "space-between"
                              : "flex-end",
                          gap: 2,
                        }}
                      >
                        <Button
                          className="button-pros"
                          variant="contained"
                          sx={{
                            width: "fit-content",
                            height: "40px",
                            backgroundImage:
                              "linear-gradient(#0ab9cc, #069dae)",
                            border: "1px solid hsl(186, 89.90%, 27.30%)",
                            borderRadius: "4px",
                            color: "#fff",
                            fontSize: "14px",
                            textTransform: "none",
                            "&:hover": {
                              backgroundImage:
                                "linear-gradient(#0991a2, #057d8c)",
                            },
                          }}
                          onClick={handleProcessReset}
                          disabled={isLoading}
                        >
                          {isLoading
                            ? "Loading..."
                            : "Set As Not Crosscoded Brand"}
                        </Button>
                        {listType == "crosscode" && (
                          <Button
                            className="button-pros"
                            variant="contained"
                            sx={{
                              backgroundImage:
                                "linear-gradient(#c43232ff, #ac2828ff)",
                              border: "1px solid hsla(0, 90%, 27%, 1.00)",
                              borderRadius: "4px",
                              color: "#fff",
                              fontSize: "14px",
                              textTransform: "none",
                              "&:hover": {
                                backgroundImage:
                                  "linear-gradient(#b02c2cff, #8a2222ff)",
                              },
                              height: "40px",
                            }}
                            onClick={handleProcessExclude}
                            disabled={isLoading}
                          >
                            {isLoading
                              ? "Loading..."
                              : "Exclude Selected Brand"}
                          </Button>
                        )}
                      </Box>
                    </Box>

                    <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                      <Table sx={{ minWidth: 650 }} aria-label="checkbox table">
                        <TableHead>
                          <TableRow sx={{ height: "10px" }}>
                            {listType == "crosscode" ? (
                              <>
                                <StyledTableCell>Select</StyledTableCell>
                                <HighlightedStyledTableCell>
                                  BRAND
                                </HighlightedStyledTableCell>
                                <StyledTableCell align="left">
                                  RET_Brand
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                  RET_Product
                                </StyledTableCell>
                                <HighlightedStyledTableCell align="left">
                                  CATEGORY
                                </HighlightedStyledTableCell>
                                <StyledTableCell align="left">
                                  RET_Category
                                </StyledTableCell>
                              </>
                            ) : (
                              <>
                                <StyledTableCell>Select</StyledTableCell>
                                <StyledTableCell>RET_Category</StyledTableCell>
                                <StyledTableCell align="left">
                                  RET_Brand
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                  RET_Product
                                </StyledTableCell>
                              </>
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {dataTable.length > 0 ? (
                            dataTable.map((row) => (
                              <StyledTableRow key={row.id}>
                                {listType == "crosscode" ? (
                                  <>
                                    <StyledTableCell align="left">
                                      <Checkbox
                                        checked={formBody.multiple_selection?.some(
                                          (item) =>
                                            item.ret_category ===
                                              row.ret_category &&
                                            item.ret_brand === row.ret_brand &&
                                            item.ret_product === row.ret_product
                                        )}
                                        onChange={handleChangeMultipleSelection(
                                          row
                                        )}
                                        color="primary"
                                      />
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.namabrand}
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                      {row.ret_brand}
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                      {row.ret_product}
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                      {row.namagroup}
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                      {row.ret_category}
                                    </StyledTableCell>
                                  </>
                                ) : (
                                  <>
                                    <StyledTableCell align="left">
                                      <Checkbox
                                        checked={formBody.multiple_selection?.some(
                                          (item) =>
                                            item.ret_category ===
                                              row.ret_category &&
                                            item.ret_brand === row.ret_brand &&
                                            item.ret_product === row.ret_product
                                        )}
                                        onChange={handleChangeMultipleSelection(
                                          row
                                        )}
                                        color="primary"
                                      />
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.ret_category}
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                      {row.ret_brand}
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                      {row.ret_product}
                                    </StyledTableCell>
                                  </>
                                )}
                              </StyledTableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={10}
                                align="center"
                                sx={{ border: 1, borderColor: "grey.300" }}
                              >
                                {isLoading ? "Loading..." : "No Data Available"}
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {dataTable.length > 0 && (
                      <TablePagination
                        rowsPerPageOptions={itemsPerPageList}
                        component="div"
                        count={totalItems}
                        rowsPerPage={itemsPerPage}
                        page={currentPage - 1}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleChangeItemPerPageSelect}
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 2,
                }}
              ></Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <ModalConfirmation
        open={openDialogConfirmationExport}
        onClose={handleCloseDialog}
        title={"Konfirmasi Download"}
        confirmationText={"Yes"}
        description={`Ditemukan ${viewDataExport.title} terakhir diproses pada ${viewDataExport.process_at}. Apakah anda yakin ingin download data ini?`}
        isLoading={isLoading}
        handleClick={handleExport}
      />
      <ModalProcessCrosscoding
        label={crosscodeLabel}
        open={processModalOpen}
        onClose={handleCloseProcess}
        onProcess={handleProcess}
        isLoading={isLoading}
        selectedProcessData={formBody.category_mode}
      />
    </Box>
  );
}

export default CrosscodedExcludedBrand;
